<template>
  <a @click="promptNumber">Go to >></a>
</template>

<script>
import routeMixin from "@/mixins/routeMixin";

export default {
  name: "Goto",
  props: ["bookId", "defaultValue", "max"],
  mixins: [routeMixin],
  methods: {
    promptNumber() {
      this.$buefy.dialog.prompt({
        message: `Enter section number:`,
        inputAttrs: {
          type: "number",
          placeholder: "Section number",
          value: this.defaultValue,
          maxlength: 2,
          min: 1
        },
        trapFocus: true,
        onConfirm: value => this.goto(value)
      });
    },
    goto(sectionNumber) {
      if (sectionNumber > this.max) return;
      this.$router.push(this.getPath(sectionNumber));
    },
    getPath(sectionNumber) {
      return this.getSectionPath(this.bookId, sectionNumber);
    }
  }
};
</script>

<style lang="scss" scoped></style>
